import './BackgroundTasksBoxFooter.scss';

type BackgroundTasksBoxFooterProps = {
	onCancelAllClicked: () => void
}

const BackgroundTasksBoxFooter = ( { onCancelAllClicked }: BackgroundTasksBoxFooterProps ) => (
	<div className="BackgroundTasksBoxFooter">
		<button
			type="button"
			className="cancel-all-button"
			onClick={onCancelAllClicked}
		>
			Cancel All
		</button>
	</div>
);

export default BackgroundTasksBoxFooter;
